/**
 *  Copyright AlpineReplay Inc, 2021. All rights reserved.
 *  Authors: Slobodan Djordjevic
 */
import React, { useState } from "react"
import { useDispatch, useSelector } from "react-redux"
import {
    ContentSection,
    AddOrEditCollection,
    Button,
    FooterSection,
    useToken,
} from "trux"
import {
    CollectionDocument,
    FindProfileDocument, ProfileDocument,
    useAddCollectionItemMutation,
    useAddCollectionMutation,
    useFindProfileQuery,
} from "../../generated/graphql"

export const CreateNewPlaylist = (props) => {
    const dispatch = useDispatch()
    const [playlistName, setPlaylistName] = useState("")
    const [error, setError] = useState("")
    const [collectionColor, setCollectionColor] = useState(1)
    const [isPrivate, setIsPrivate] = useState(false)
    let moment = useSelector((state) => state.video.value.source)
    if(props.moment) {
        moment = props.moment
    }
    const setName = (name) => {
        if (name) {
            setError("")
            setPlaylistName(name)
            return true
        } else {
            setPlaylistName(name)
            setError("Name your playlist")
            return false
        }
    }

    const setPlaylistColor = (color) => {
        setCollectionColor(color)
    }

    const setPrivacy = (value) => {
        setIsPrivate(value)
    }

    const token = useToken("CreateNewPlaylist")
    const tokenReady = token != null

    const {
        data: profileData,
        loading: profileLoading,
        error: profileError,
    } = useFindProfileQuery({
        variables: {
            user_id: props?.selectedUser?.user_id,
            token: token,
        },
        skip: !tokenReady,
    })

    const [
        addCollectionMutation,
        {
            data: addCollectionData,
            loading: addCollectionLoading,
            error: addCollectionError,
        },
    ] = useAddCollectionMutation({
        variables: {
            token: token,
        },
        refetchQueries: [FindProfileDocument, "findProfile"],
    })

    const [
        addCollectionItem,
        {
            data: addCollectionItemData,
            loading: addCollectionItemLoading,
            error: addCollectionItemError,
        },
    ] = useAddCollectionItemMutation({
        variables: {
            token: token,
        },
        refetchQueries: [FindProfileDocument, "findProfile", CollectionDocument, "collection", ProfileDocument, "profile"]
    })

    const addNewCollection = () => {
        if (playlistName && !error) {
            addCollectionMutation({
                variables: {
                    edit: {
                        title: playlistName,
                        public: !isPrivate,
                        color: collectionColor,
                    },
                    user_playlist_id: profileData?.profile?.user_playlist_id,
                },
            }).then((response) => {
                if (response?.data?.addCollection?.success) {
                    addCollectionItem({
                        variables: {
                            hash_key: response.data.addCollection.hash_key,
                            add: {
                                user_playlist_clip_id:
                                    moment.game_clip_id,
                            },
                        },
                    }).then((res) => {
                        if (res?.data?.addCollectionItem?.success) {
                            props.showConfirmation(
                              profileData?.profile?.hash_key,
                              response.data.addCollection.hash_key,
                              res.data.addCollectionItem.user_playlist_clip_id)
                        } else {
                            props.onClose()
                            dispatch({
                                type: "COMMON_SET",
                                key: "toast",
                                value: "Something went wrong",
                            })
                            console.log(
                                "Something went wrong with adding item to created collection"
                            )
                        }
                    })
                } else {
                    props.onClose()
                    dispatch({
                        type: "COMMON_SET",
                        key: "toast",
                        value: "Something went wrong",
                    })
                    console.log("Something went wrong with adding collection")
                }
            })
        } else {
            setError("Name your playlist")
        }
    }

    return (
        <>
            <ContentSection>
                <AddOrEditCollection
                    name={playlistName}
                    setName={setName}
                    error={error}
                    color={collectionColor}
                    setPlaylistColor={setPlaylistColor}
                    isPrivate={isPrivate}
                    setPrivacy={setPrivacy}
                />
            </ContentSection>
            <FooterSection>
                <Button
                    disabled={!playlistName}
                    primary
                    onClick={() => addNewCollection()}
                    content="Create and add moment"
                />
            </FooterSection>
        </>
    )
}
